import { SearchInput } from '@billy/design-system'
import React, { ChangeEvent, ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../../../../../hooks'
import { useBankLinesFilters } from '../../../../../../../paymentReconciliationModal/contexts'

export const BankLinesSearchInput = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { bankLinesSearchQuery, setBankLinesSearchQuery } = useBankLinesFilters()

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setBankLinesSearchQuery(event.target.value || undefined)
      track('xxx - expenses - Bank line modal - search used')
    },
    [setBankLinesSearchQuery, track],
  )

  const handleClear = useCallback(() => {
    setBankLinesSearchQuery(undefined)
  }, [setBankLinesSearchQuery])

  return (
    <SearchInput
      onChangeDebounced={handleChange}
      onClear={handleClear}
      value={bankLinesSearchQuery}
      placeholder={`${t('search')}...`}
      size="md"
    />
  )
}
